/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginViewResponse
 */
export interface LoginViewResponse {
    /**
     * 
     * @type {string}
     * @memberof LoginViewResponse
     */
    intermediateToken: string;
    /**
     * 
     * @type {string}
     * @memberof LoginViewResponse
     */
    deviceType: string;
}

/**
 * Check if a given object implements the LoginViewResponse interface.
 */
export function instanceOfLoginViewResponse(value: object): value is LoginViewResponse {
    if ((!('intermediateToken' in (value as Record<string, any>)) && !('intermediate_token' in (value as Record<string, any>))) || ((value as Record<string, any>)['intermediateToken'] === undefined && (value as Record<string, any>)['intermediate_token'] === undefined)) return false;
    if ((!('deviceType' in (value as Record<string, any>)) && !('device_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceType'] === undefined && (value as Record<string, any>)['device_type'] === undefined)) return false;
    return true;
}

export function LoginViewResponseFromJSON(json: any): LoginViewResponse {
    return LoginViewResponseFromJSONTyped(json, false);
}

export function LoginViewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginViewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'intermediateToken': json['intermediate_token'],
        'deviceType': json['device_type'],
    };
}

export function LoginViewResponseToJSON(json: any): LoginViewResponse {
    return LoginViewResponseToJSONTyped(json, false);
}

export function LoginViewResponseToJSONTyped(value?: LoginViewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'intermediate_token': value['intermediateToken'],
        'device_type': value['deviceType'],
    };
}

